<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div *ngIf="currentUser">

    <table class="table" style="background-color:white;">
      <tr>
        <td style="background-color:#0f2b46;color:white;" colspan="2"> UPLOAD A DEBIT/CREDIT CARD </td>
        <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
      </tr>
    </table>



    <form (ngSubmit)="upload()" [formGroup]="kycForm">


      <label for="" class="font-weight-bold ">
        Note :- Take a Clear photo of your Visa/Master card you want to use for transaction showing complete card details.
      </label>
      <div class="img-height" *ngIf="imgURLCard">
        <img [src]="imgURLCard" />
      </div>

      <div class="custom-file  mt-2">
        <input type="file" class="custom-file-input" id="customFile" #file2 accept='image/*'
               (change)="preview(file2.files,2)">
        <label class="custom-file-label" for="customFile">Choose file</label>
      </div>
      <mat-error *ngIf="!cardImage">
        {{msg2}}
      </mat-error>

      <mat-form-field>
        <mat-label>Select Card Type</mat-label>
        <mat-select formControlName="KycType1" matTooltip="Select Card Type" autocomplete="off" required>
          <mat-option *ngFor="let d of Cardprooflist; let i=index" [value]="d.id">
            {{d?.doc_Name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="submitted && f.KycType1.errors">
          Select Card Type
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput placeholder="Enter Full Card Number" formControlName="CardNumber"
               minlength="19" maxlength="19" (blur)="transform()"
               required />
        <mat-error *ngIf="submitted && f.CardNumber.errors">
          Enter Full Card Number
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Expiry Date"
               [matDatepicker]="picker2" maxlength="7" [min]="currentDate"
               formControlName="kycExpiry1" required>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>

        <mat-datepicker #picker2></mat-datepicker>
        <mat-error *ngIf="submitted && f.kycExpiry1.errors">
          Choose Expiry Card Date
        </mat-error>
      </mat-form-field>


      <button type="submit" mat-raised-button color="primary" class="set-mobile login-btn">

        Submit
      </button>




    </form>
  </div>
</fieldset>

